import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./styles/main.css";
import { App } from "./App.tsx";
import { registerServiceWorker } from "./lib/sw-registration.ts";

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root not found in index.html");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// SW registration is gated to production builds — dev keeps fresh modules.
if (import.meta.env.PROD) {
  registerServiceWorker();
}
